<template>
    <div class="slm-item-list__loader">
        <div class="slm-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loader-component'
}
</script>